import { usePhoneCampaign } from '@hc-frontend/core-ui';

/**
 * Renders TTY/schedule text without any styling, for use in Builder in Unbounce-migrated pages
 */
export default function UnstyledTTYToday() {
  const phoneCampaign = usePhoneCampaign();

  if (phoneCampaign) {
    return <div className="[all:inherit]">{phoneCampaign.todayTTY}</div>;
  }
}
